import React from 'react'
import Page from '../../components/page/page'
import Footer from '../../components/footer/footer.jsx'
import PageContentMargin from '../../components/page-content-margin/page-content-margin'
import HelperList from './helper-list'

const HelperCenter = () => {
  const helperList = [
    {
      id: 0,
      name: '学生端-帮助视频',
      cover: '../../../../static/student.png',
      videoUrl: 'https://pkcode.oss-cn-hangzhou.aliyuncs.com/scratch/video/%E5%8A%A0%E6%B0%B4%E5%8D%B0-%E5%AD%A6%E7%94%9F%E6%93%8D%E4%BD%9C%E8%A7%86%E9%A2%91.mp4'
    }, {
      id: 1,
      name: '教师端-帮助视频',
      cover: '../../../../static/teacher.png',
      videoUrl: 'https://pkcode.oss-cn-hangzhou.aliyuncs.com/scratch/video/%E5%8A%A0%E6%B0%B4%E5%8D%B0-%E8%80%81%E5%B8%88%E6%93%8D%E4%BD%9C%E8%A7%86%E9%A2%91.mp4'
    },
    {
      id: 2,
      name: '下载谷歌浏览器',
      cover: '../../../../static/google.png',
      videoUrl: ''
    },
    {
        id: 3,
        name: 'Windows客户端下载',
        cover: '../../../../static/windows.png',
        videoUrl: ''
    }
  ]
  return (
    <Page isModal={true} title={window.L('teach.user.helper')}>
      <PageContentMargin>
        <HelperList helpers={helperList} />
      </PageContentMargin>
      {/* <Footer /> */}
    </Page>
  )
}

export default HelperCenter
